import { selector } from 'recoil';
import format from 'date-fns/format';

import { submissionResultState } from 'state/atoms/submit';

export const submissionTimestamp = selector({
  key: 'FormattedSubmissionTimestamp',
  get: ({ get }) => {
    const submissionResult = get(submissionResultState);
    if (submissionResult?.timestamp_utc) {
      return format(
        new Date(submissionResult.timestamp_utc),
        'dd/MM/yyyy hh:mm a'
      );
    }
    return '';
  },
});
